import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import ProfileHeader from '../components/users/UserProfile/ProfileHeader';
import PlanHistory from '../components/users/UserProfile/PlanHistory';
import ActivityFeed from '../components/users/UserProfile/ActivityFeed';
import UserAccessLog from '../components/users/UserProfile/UserAccessLog';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import useDidFetch from '../custom_hooks/useDidfetch';
import { ROLE } from '../constant/roles';
import ActivePlanCard from '../components/users/UserProfile/ActivePlanCard';
import SessionHistoryCard from '../components/users/UserProfile/SessionHistoryCard';

const UserProfilePage = () => {
    const { userId } = useParams();
    const [user, setUser] = useState(null);
    const [role, setRole] = useState(null);
    const [planHistory, setPlanHistory] = useState(null);
    const [sessionHistory, setSessionHistory] = useState([]);
    const runOnce = useDidFetch();

    useEffect(() => {
        runOnce(() => {
            const storedUser = localStorage.getItem("user");
            const user = storedUser ? JSON.parse(storedUser) : null;
            setRole(ROLE[user?.role_id]);
            const userData = getUserById(userId);
            console.log(userId);
            setUser(userData);
            getUserPlanHistory();
            getSessionHistory()
        });
    }, [userId]);

    const getSessionHistory = async () => {
        try {
            let response = await api.get(`${ENDPOINTS.getSessionByUser}/${userId}`);
            let result = response?.data ?? {};
            if (response.status === 200 || response.status === 201) {
                setSessionHistory(prev => {
                    if (!result) return prev; 
                    if (typeof result === "object" && !Array.isArray(result)) {
                        return [...prev, result];
                    } 
                    return [...prev, ...result];
                });

            }
        } catch (error) {
            console.log("setSessionHistory error", error);
        }
    }
    const getUserPlanHistory = async () => {
        try {
            let response = await api.get(`${ENDPOINTS.getPlanHistoryByUser}/${userId}`);
            let result = response?.data ?? {};
            if (response.status === 200 || response.status === 201) {
                setPlanHistory(result ?? {});
            }
        } catch (error) {
            console.log("getUserPlanHistory error", error);
        }
    }

    const getUserById = async (id) => {
        try {
            let response = await api.get(`${ENDPOINTS.getUserById}/${id}`);
            let result = response?.data ?? {};
            if (response.status === 200 || response.status === 201) {
                setUser(result?.user ?? {});
            }
        } catch (error) {
            console.log("getuserid error", error);
        }
    }

    if (!user) {
        return (
            <div className="flex items-center justify-center h-full">
                <p className="text-gray-500">Loading user profile...</p>
            </div>
        );
    }

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
        >
            <div>
                <Link to={role == 'receptionist' ? "/receptionist/members" : "/admin/users"} className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-brand-red">
                    <ArrowLeft size={18} />
                    Back to User List
                </Link>
            </div>

            <ProfileHeader user={user} />

            <motion.div
                className="grid grid-cols-1 lg:grid-cols-2 gap-6"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <div className="lg:col-span-1 space-y-6">
                    <SessionHistoryCard userDetails={user ?? {}} sessionHistory={sessionHistory}/>
                    <PlanHistory userDetails={user ?? {}} planHistory={planHistory ?? []} />
                </div>
                <div className="lg:col-span-1">
                    <UserAccessLog userId={user.member_id} />
                </div>
                {/* <div className="lg:col-span-1">
                    <ActivityFeed activityLog={user?.activityLog ?? []} />
                </div> */}
            </motion.div>
        </motion.div>
    );
};

export default UserProfilePage;
